import CategorieConverter from './CategorieConverter';
import NumConverter from './NumConverter';
import StrConverter from './StrConverter';
import CombinedConverter from './CombinedConverter';
export default class ProductConverter extends CombinedConverter {

  constructor(categories, combosCategories)
  {
    super(
      new CategorieConverter(['METIER', 'SCATEGORIE'], ['category'], {
        categories,
        subCategories: combosCategories,
        format: true
      }),
      new NumConverter(['REF'], ['reference']),
      new StrConverter(['DESIGNATION'], ['name']),
      new StrConverter(['DESCRIPTION'], ['desc']),
      new StrConverter(['IMAGE'], ['img']),
      new StrConverter(['MARQUE'], ['mark']),
      new NumConverter(['PRIX ACHAT'], ['unitPrice']),
      new NumConverter(['PRIX VENTE'], ['salePrice'])
    );
  }
}
